import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { isLoggedIn } from "../utils/auth";
import axioswToken from "../api/axios";
import { URL } from "../url/api";
import { safeSessionStorage } from "../utils/safeStorage";

const DISMISS_KEY = "email_reminder_dismissed";

export default function EmailReminderBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!isLoggedIn() || safeSessionStorage.getItem(DISMISS_KEY) === "1") return;

    let cancelled = false;
    axioswToken
      .get(`${URL}/getProfile`)
      .then((res) => {
        if (cancelled) return;
        if (!res?.data?.data?.email) setShow(true);
      })
      .catch(() => {});

    return () => {
      cancelled = true;
    };
  }, []);

  const dismiss = () => {
    safeSessionStorage.setItem(DISMISS_KEY, "1");
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="email-reminder-bar">
      <div className="email-reminder-bar-inner">
        <i className="fas fa-envelope-open-text"></i>
        <span>Add your email address to receive order updates &amp; receipts.</span>
        <Link to="/profile#account" className="email-reminder-cta" onClick={dismiss}>
          Add Email
        </Link>
        <button className="email-reminder-close" onClick={dismiss} aria-label="Dismiss">
          <i className="fas fa-times"></i>
        </button>
      </div>
    </div>
  );
}
